import { useEffect, useState } from "react";
import Tab1 from "./Tab1";
import Table from "./Table";
import ApiResponseBox from "../../../Components/ApiResponseBox";
import Button from "../../../Core/Button/Button";
import FormLayout from "../../../Core/Layout/FormLayout";
import { useGetWorkOrderWithCollectionQuery, usePostFinalStockAssemblyMutation } from "../../../store/api/assemblyapi";
import OperationLeft from "./Operations/OperationLeft";
import OperationRight from "./Operations/OperationRight";
import { useLocation, useNavigate } from "react-router-dom";
import GetIcon from "../../../utils/Icon";
import Collection from "./Collection/Collection";

const AssemblyForm = () => {
  const nvg = useNavigate()
  const [tab, settab] = useState(1)
  const [podate, setpodate] = useState(new Date().toISOString().split('T')[0])
  const [error, setError] = useState('');
  const [ptype, setptype] = useState("Error")
  const [showError, setShowError] = useState(false);
  const [finalstep, setfinalstep] = useState(false);
  const [activityboll, setactivityboll] = useState(true)
  const [finish, setfinish] = useState(false);
  const [finishApiResponse, setfinishApiResponse] = useState(null);
  const [selectWOItem, setselectWOItem] = useState("");
  const [selectWOBOM, setselectWOBOM] = useState("");
  const [fulldata, setfulldata] = useState({});
  const [QtyToManufacture, setQtyToManufacture] = useState('');
  const [requiredItem, setrequiredItem] = useState([]);
  const [operation, setoperation] = useState([]);
  const [stockEntries, setstockEntries] = useState({});
  const [fieldErrors, setFieldErrors] = useState({
    WOItem: false,
    WOBOM: false,
    QTY: false,
    items: false
  });

  const location = useLocation();
  console.log("localtion is here",location);
  const { data: WODetail, isLoading: Detail_Loader } = useGetWorkOrderWithCollectionQuery(location.state.assemblyID);
  useEffect(() => {
    if (!Detail_Loader) {
      setpodate(WODetail?.message?.main_doc?.creation.split(' ')[0]);
      setselectWOItem(WODetail?.message?.main_doc?.item_name);
      setfinish(WODetail?.message?.main_doc?.status);
      setselectWOBOM(WODetail?.message?.main_doc?.bom_no);
      setQtyToManufacture(WODetail?.message?.main_doc?.qty);
      setrequiredItem(WODetail?.message?.main_doc?.required_items);
      setoperation(WODetail?.message?.main_doc?.operations);
      setfulldata(WODetail?.message?.main_doc);
      setstockEntries(WODetail?.message?.linked_documents);


    }
  }, [WODetail, Detail_Loader])
  const [finishedApi] = usePostFinalStockAssemblyMutation()
  const finishedFunction = async () => {
    try {
     const response = await finishedApi({work_order_id:location.state.assemblyID,purpose:"Manufacture",qty:fulldata.qty});
     console.log("sdfghjhgfdsasdfggfdsas",response);
      setptype("Message");
      setError("Final Stock Entry created successfully");
      setShowError(true);
      setfinishApiResponse(response);
      setTimeout(() => {nvg("/assmbly/stock-entry",{state:response.data.message.data.name})}, 2000);
  } catch (error) {
    console.log("check error msg",error)
  }
  }


  return (
    <FormLayout
      title="View Work Order"
      breadcrumbs={[
        { label: "Work Order" },
        { label: "Work Order List", url: "/assmbly/assembly-list" }
      ]}
      status={'hide'}
      finalStep={finalstep}
      actionButtons={
        <>
          {/* <Button
            className="custom-btn-00989"
            onClick={SubmitPurchaseOrder}
            iconName="LuFilePlus2"
            style={{ gap: '2px', height: '28px' }}
            iconSize={12}
            display={finalstep ? 'none' : 'flex'}
          >
            Submit
          </Button>

          */}

          <Button
           onClick={finishedFunction}
            style={{ backgroundColor: '#fff', height: '28px' }}
            className="custom-btn-00989blue"
            display={finish == "In Process" ? "flex" : "none"}
          >
          Finish
          </Button> 


        </>
      }
    >
      <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff",flexGrow:'1' }}>
        <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
          <div className="d-flex justify-content-between align-items-end ">

            <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
              <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner" >
                <button
                  type="button"
                  className={tab === 1
                    ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                    : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                  }
                  onClick={() => settab(1)}
                >
                  Production Item {tab == 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}

                </button>
              </li>
              {operation.length > 0 && <li className="nav-item-tab-custom pb-0 d-flex align-items-end border-radius-top-corner"  >
                <button
                  type="button"
                  className={tab === 2
                    ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                    : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                  }
                  onClick={() => settab(2)}
                >
                  Operations {tab == 2 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}

                </button>
              </li>}


               <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner" >
                <button
                  type="button"
                  className={tab === 3
                    ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                    : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                  }
                  onClick={() => settab(3)}
                >
                  Collections {tab == 3 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}

                </button>
              </li>
            </ul>

            <div className="d-flex align-items-center mb-2 px-3" style={{ gap: "2px", fontSize: '12px' }}>
              <span style={{ position: 'relative', top: '-1px' }}>
                <GetIcon iconName="CgAttachment" size={12} />
              </span>
              <span className=" fw-semibold" style={{ color: "#391F84" }}>
                Attachments
              </span>
            </div>

          </div>
        </div>



        {tab == 1 ? <div className="row justify-content-between" style={{ marginTop:'14px', display:"flex", overflow: 'hidden',flexGrow:'1' }}>
          <div className="col-3 " style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px' }}>
            <Tab1
              activityboll={activityboll}
              WOI={{ setselectWOItem, selectWOItem, Error: fieldErrors.WOItem }}
              WOBOM={{ setselectWOBOM, selectWOBOM, Error: fieldErrors.WOBOM }}
              qty={{ setQtyToManufacture, QtyToManufacture, Error: fieldErrors.QTY }}
              podate={{ podate, setpodate }} ponumber={location?.state?.assemblyID}
            />
          </div>
          <div className="col-9 d-flex flex-column mt-2" style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px', minHeight: tab == 1 ? '440px' : '0' }}>
            <div className="d-flex pb-2" style={{ gap: '5px' }}>
              <p className="NoOfLine">No. of lines - <span style={{ color: '#2563EB' }}> {requiredItem.length}</span></p>
              <p className="TotalQty">Total Quantity -  <span style={{ color: '#16A34A' }}> {requiredItem.reduce((total, item) => { return total + Number(item.required_qty); }, 0)}</span></p>
            </div>
            <div className="tableLabel">
              <div style={{ width: '98.5%', borderBottom: '1px solid #caced3', marginBottom: '6px' }}></div>
              <p className="" style={{ color: "#1E1E1E", fontWeight: '500', marginBottom: '4px', fontSize: '15px' }}>
                Required Items
              </p>
            </div>
            <Table TB_data={requiredItem} />

          </div>

        </div> : ''}
        


       {tab == 2 ? <div className="row justify-content-between" style={{ marginTop:'14px', display:"flex", overflow: 'hidden',flexGrow:'1' }}>
          <div className="col-3 ">
            <OperationLeft
              TMA={fulldata?.transfer_material_against}
            />
          </div>
          <div className="col-9 d-flex flex-column mt-1">
            <div className="tableLabel">
              <p className="" style={{ color: "#1E1E1E", fontWeight: '500', marginBottom: '4px' }}>
                Operations
              </p>
            </div>
            <OperationRight TB_data={operation} />
          </div>
        </div> : ''} 

        {tab == 3 ? <div className="row justify-content-between" style={{padding: "0px 8px", borderRadius: "5px", marginTop: tab == 3 ? '14px' : '0', display:"flex", overflow: 'hidden',flexGrow:'1' }}>
         <Collection stockEntries={stockEntries} />
        </div> : ''}





      </div>
      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />
    </FormLayout>
  );
};

export default AssemblyForm;